
import { defineComponent, ref, toRaw } from 'vue';
import { useRoute } from 'vue-router';
import {
  getMessageInfo,
} from '@/api/message-center';
import type { IMessageInfoRes } from '@/api/message-center/type.d';
import MonacoEditor from '@/components/monaco-editor/index.vue';
import { IS_DELETE_LIST } from '@/constant/message-center';
import { getLabelByVal } from '@/core/utils/index';
import { formatTime } from '@toy/utils';

export default defineComponent({
  components: {
    MonacoEditor,
  },
  setup() {
    const $route = useRoute();
    const messageId = $route.params.messageId as string;

    const messageDetail = ref({} as IMessageInfoRes);

    const getMessageDetail = async () => {
      const { data } = await getMessageInfo(messageId);
      messageDetail.value = data;
    };

    const messageDetailKeyMap = {
      taskId: {
        label: '任务ID',
      },
      status: {
        label: '消息状态',
      },
      requester: {
        label: '消息发送方',
      },
      responder: {
        label: '消息消费方',
      },
      lockKey: {
        label: '消息锁定KEY',
      },
      indexInfo: {
        label: '索引',
      },
      nextRetry: {
        label: '下一次重试时间',
        formatter: (value: string) => formatTime(value),
      },
      startTime: {
        label: '消费开始时间',
        formatter: (value: string) => formatTime(value),
      },
      executeStep: {
        label: '执行步骤',
      },
      configCode: {
        label: '消息配置CODE',
      },
      messageType: {
        label: '消息类型',
      },
      // messageBody: {
      //   label: '消息体',
      // },
      exchange: {
        label: 'MQ exchange',
      },
      queue: {
        label: 'MQ Queue',
      },
      routing: {
        label: 'MQ routing',
      },
      executeService: {
        label: '执行服务',
      },
      executeTime: {
        label: '执行时间',
        formatter: (value: string) => formatTime(value),
      },
      executeCount: {
        label: '执行次数',
      },
      tryCount: {
        label: '重试次数',
      },
      isDeleted: {
        label: '是否删除',
        formatter: (value: string) => getLabelByVal(IS_DELETE_LIST, value),
      },
      createdTime: {
        label: '创建时间',
        formatter: (value: string) => formatTime(value),
      },
      remark: {
        label: '备注信息',
      },
      // messageParams: {
      //   label: '额外的参数',
      // },
    };

    const detailDialogInfo = ref({
      visible: false,
      value: '',
      title: '',
    });
    const handleShowDetail = (key: keyof IMessageInfoRes, title: string) => {
      let value = toRaw(messageDetail.value[key]);
      if (typeof value !== 'string') {
        try {
          value = JSON.stringify(value);
        } catch (e) {
          value = '';
          console.error(e);
        }
      }
      detailDialogInfo.value.visible = true;
      detailDialogInfo.value.value = value;
      detailDialogInfo.value.title = title;
    };

    const init = () => {
      getMessageDetail();
    };
    init();

    return {
      messageDetail,
      messageDetailKeyMap,
      handleShowDetail,
      detailDialogInfo,
    };
  },
});
